/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { GrantTokenResponseDto } from '@ink-ai/insight-service-sdk';
import { AppParam } from '../reducers/app';

const APP_PARAM_TOKEN = 'INK_AI_APP_PARAM_20250331';

export const storeTokens = (grantTokenResp: GrantTokenResponseDto | null) => {
  if (grantTokenResp === null) {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('expiresAt');
    return;
  }
  localStorage.setItem('accessToken', grantTokenResp.access_token);
  grantTokenResp.refresh_token &&
    localStorage.setItem('refreshToken', grantTokenResp.refresh_token);
  localStorage.setItem('idToken', grantTokenResp.id_token);
  localStorage.setItem('expiresAt', grantTokenResp.expires_at.toString());
};

export const clearAll = () => localStorage.clear();

export const getTokens = (): GrantTokenResponseDto => ({
  access_token: localStorage.getItem('accessToken'),
  refresh_token: localStorage.getItem('refreshToken'),
  id_token: localStorage.getItem('idToken'),
  expires_at: parseInt(localStorage.getItem('expiresAt')),
});

export const storeAppParam = (appParam: AppParam) =>
  localStorage.setItem(APP_PARAM_TOKEN, JSON.stringify(appParam));

export const getAppParam = (): AppParam | null => {
  const appParamString = localStorage.getItem(APP_PARAM_TOKEN);
  if (appParamString) {
    return JSON.parse(appParamString);
  }
  return null;
};
